import { useState } from "react";
import { Props_SnippetLearnMore } from "./LearnMore.props";
import SnippetLink from "../Shared/Link/Link";

const SnippetLearnMore = (props: Props_SnippetLearnMore) => {
    const { heading, backgroundImage, repeatable_card } = props;

    const [snippetID] = useState(() =>
        Math.random().toString(36).substring(2, 10)
    );

    const classHeadingVisibility: string = heading.visibility.value
        ? `snippet-learn-more__heading--${heading.visibility.value}`
        : "";

    return (
        <section className={`snippet-learn-more`}>
            {backgroundImage?.image?.value && (
                <div className="snippet-learn-more__background">
                    <img
                        src={backgroundImage.image.value}
                        alt={backgroundImage.alt?.value || ""}
                        className="snippet-learn-more__background-image"
                        loading="lazy"
                    />
                </div>
            )}

            <div className="snippet-learn-more__container">
                <div className="snippet-learn-more__header">
                    {heading?.content?.value && (
                        <h2
                            id={`snippet-learn-more-${snippetID}`}
                            className={`snippet-learn-more__heading ${classHeadingVisibility}`}
                        >
                            {heading.content.value}
                        </h2>
                    )}
                </div>

                <div className="snippet-learn-more__cards">
                    {repeatable_card.map((card, index: number) => (
                        <article
                            key={`snippet-learn-more-${snippetID}-${index}`}
                            className="snippet-learn-more__card"
                        >
                            {card.image?.value && (
                                <figure className="snippet-learn-more__card-image-container">
                                    <img
                                        className="snippet-learn-more__card-image"
                                        loading="lazy"
                                        src={card.image.value}
                                        alt={card.alt?.value || ""}
                                        width="300"
                                        height="200"
                                    />
                                </figure>
                            )}

                            <div className="snippet-learn-more__card-content">
                                {card.linkHref?.value && (
                                    <SnippetLink
                                        linkStyles={card.linkStyle?.value}
                                        className="snippet-learn-more__card-link"
                                        url={card.linkHref.value}
                                        openInNewTab={
                                            card.linkTarget?.value === "true"
                                        }
                                        rel={
                                            card.linkTarget?.value === "true"
                                                ? "noopener noreferrer"
                                                : undefined
                                        }
                                        aria-label={`${card.linkText?.value || "Learn more"}`}
                                    >
                                        {card.linkText?.value}
                                    </SnippetLink>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SnippetLearnMore;
